import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import styled from 'styled-components'

import { Loader } from '@happymoneyinc/matter'

import { createClient } from '../../utils/prismic'
import { getPageData, getComponentData } from '../../utils/getPageData'
import { loggerClient } from '../../utils/loggerClient'

import Hero from '../../components/careers/Hero'
import Intro from '../../components/careers/Intro'
import Beliefs from '../../components/careers/Beliefs'
import Stats from '../../components/careers/Stats'
import Values from '../../components/Values'
import Perks from '../../components/careers/Perks'
import OpenJobs from '../../components/careers/OpenJobs'
import { REVALIDATE_TIME_INTERVAL } from '../../data/constants'

const Careers = (props) => {
  const { data } = props
  const {
    values_eyebrow: eyebrow,
    values_headline: headline,
    values_subtext: subtext,
    values: items,
  } = getComponentData({
    data,
    key: 'values',
  })

  const [departments, setDepartments] = useState([])
  const [noOpenJobs, setNoOpenJobs] = useState(false)
  const [count, setCount] = useState(0)

  useEffect(() => {
    async function fetchData() {
      const allJobsAPI = process.env.NEXT_PUBLIC_LEVER_POSTINGS_API
      const departmentsAPI = `${ allJobsAPI }?group=team`

      // Departments Data
      try {
        const { data: departmentsData } = await axios.get(departmentsAPI)

        if (departmentsData.length > 0) {
          setDepartments(departmentsData)

          setCount(
            departmentsData.map((dept) => dept.postings.length).reduce((acc, current) => acc + current),
          )
        } else {
          setNoOpenJobs(true)
        }
      } catch (error) {
        loggerClient.error(`Error calling ${ departmentsAPI }`, {
          error,
        })
      }
    }
    fetchData()
  }, [])

  return (
    <>
      <Hero
        data={getComponentData({
          data,
          key: 'hero',
        })}
      />
      <Intro
        data={getComponentData({
          data,
          key: 'intro',
        })}
      />
      <Beliefs
        data={getComponentData({
          data,
          key: 'beliefs',
        })}
      />
      <Stats
        jobsCount={count}
        data={getComponentData({
          data,
          key: 'stats',
        })}
      />

      {departments ?
        (
          <OpenJobs departments={departments} />
        ) :
        (
          noOpenJobs && (
            <SpaceHolder>
              <StyledLoader />
            </SpaceHolder>
          )
        )}
      <Values
        eyebrow={eyebrow}
        headline={headline}
        headlineSize="large"
        subtext={subtext}
        subtextSize="large"
        items={items}
        valueHeadlineMb="8px"
      />
      <Perks
        data={getComponentData({
          data,
          key: 'perks',
        })}
      />
    </>
  )
}

export async function getStaticProps({ preview = null, previewData = {} }) {
  const client = createClient({ previewData })

  if (preview) {
    const { data } = await client.getByUID('careers', 'careers')

    return {
      props: {
        preview,
        data,
      },
      revalidate: 1,
    }
  }

  const data = await getPageData({ uid: 'careers' })

  return {
    props: {
      data,
    },
    revalidate: REVALIDATE_TIME_INTERVAL,
  }
}

const StyledLoader = styled(Loader)`
  margin-top: 5rem;
`

const SpaceHolder = styled.div`
  min-height: 800px;
`

Careers.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired
}

export default Careers
